import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import React, { ChangeEvent, useCallback } from 'react';
import { LetterTypes } from '../types';

export interface PricingSelectProps {
  letterType: LetterTypes;
  onChange: (letter: LetterTypes) => void;
}

const PricingSelect = ({ letterType, onChange }: PricingSelectProps) => {
  const handleOnChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, value: string) => {
      onChange(value as LetterTypes);
    },
    [onChange],
  );

  return (
    <FormControl>
      <FormLabel>Pricing</FormLabel>
      <RadioGroup value={letterType} onChange={handleOnChange} row>
        <FormControlLabel
          value={LetterTypes.otaf}
          control={<Radio />}
          label="Higher Pricing"
        />
        <FormControlLabel
          value={LetterTypes.otafSamePrice}
          control={<Radio />}
          label="Same Pricing"
        />
      </RadioGroup>
    </FormControl>
  );
};

export default PricingSelect;
